<div class="container-fluid payment-history-root">
  <div *ngIf="permissionsService.hasDashboardConfigSettlement" class="d-flex justify-content-end meter-type-tabs">
    <div class="meter-type-tab active">
      <span>{{ 'PAYMENT_HISTORY.TAB_PAYMENTS' | translate }}</span>
    </div>
    <div *ngIf="permissionsService.isSettlementViewAllowed" class="meter-type-tab" routerLink="/payment-history/settlements">
      <span>{{ 'PAYMENT_HISTORY.TAB_SETTLEMENTS' | translate }}</span>
    </div>
  </div>

  <div class="stats-root">
    <div id="payment-history_card_total-payment" class="stats-item">
      <div>{{ 'PAYMENT_HISTORY.TOTAL_PAYMENT' | translate }}</div>
      <div>{{ summary.totalPayment | number:'1.2-2' }} {{ currency }}</div>
    </div>
    <div id="payment-history_card_escrow-balance" class="stats-item">
      <div>{{ 'PAYMENT_HISTORY.ESCROW_BALANCE' | translate }}</div>
      <div>{{ summary.escrowBalance | number:'1.2-2' }} {{ currency }}</div>
    </div>
    <div id="payment-history_card_total-transactions" class="stats-item">
      <div>{{ 'PAYMENT_HISTORY.TOTAL_TRANSACTIONS' | translate }}</div>
      <div>{{ summary.totalTransactions | number }}</div>
    </div>
    <div id="payment-history_card_successful" class="stats-item">
      <div>{{ 'PAYMENT_HISTORY.SUCCESSFUL' | translate }}</div>
      <div>{{ summary.successful | number }}</div>
    </div>
    <div id="payment-history_card_pending" class="stats-item">
      <div>{{ 'PAYMENT_HISTORY.PENDING' | translate }}</div>
      <div>{{ summary.pending | number }}</div>
    </div>
    <div id="payment-history_card_failed" class="stats-item">
      <div>{{ 'PAYMENT_HISTORY.FAILED' | translate }}</div>
      <div>{{ summary.failed | number }}</div>
    </div>
  </div>

  <div class="table-root">
    <div class="table-root-child">
      <div class="table-action-wrapper d-flex align-items-center justify-content-between">
        <div class="d-flex searches">
          <div id="payment-history_search" class="search-input">
            <img src="../../assets/icons/search.svg" alt="Search icon" (click)="createFilterCards()" />
            <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText"
              (keydown.enter)="createFilterCards()" />
          </div>
          <div id="payment-history_search-by" class="search-type-picker">
            <div class="dropdown" (click)="showSelectSearchType = !showSelectSearchType" click-stop-propagation
              [title]="selectedSearchTypeDisplay | translate">
              <span>{{'COMMON.BY' | translate}}:</span>
              <span>{{ selectedSearchTypeDisplay | translate }}</span>
              <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
            </div>
            <div class="dropdown-opened" *ngIf="showSelectSearchType">
              <div [id]="'payment-history_search-by-' + (i + 1)" (click)="selectSearchType(searchType)"
                *ngFor="let searchType of searchByOptions; let i = index">
                <div>{{ searchType.translation | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-auto d-flex">
          <div class="d-flex">
            <div id="payment-history_date-from" class="datepicker-container">
              <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
              <input type="date" id="dateFrom" name="dateFrom" class="date-input"
                [ngClass]="dateFrom > dateTo ? 'btn datepicker-icon-error' : 'btn datepicker-icon'"
                [(ngModel)]="dateFrom" (change)="createFilterCards()" />
            </div>
            <div id="payment-history_date-to" class="datepicker-container">
              <label for="dateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
              <input type="date" id="dateTo" name="dateTo" class="date-input"
                [ngClass]="dateFrom > dateTo ? 'btn datepicker-icon-error' : 'btn datepicker-icon'"
                [(ngModel)]="dateTo" (change)="createFilterCards()" />
            </div>
            <button *ngIf="permissionsService.isPaymentHistoryDownloadAllowed" class="btn btn-icon" (click)="download()">
              <span>{{'COMMON.DOWNLOAD' | translate}}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="filter">
        <div class="filter-list">
          <app-multi-select-dropdown id="payment-history_status_filter" class="multiselect" [clicked]="clicked"
            [items]="paymentStatusItems" [label]="'COMMON.PAYMENT_STATUS.SINGLE'" [showMore]="false"
            [requireApply]="true" (shareIndividualCheckedList)="selectStatus()">
          </app-multi-select-dropdown>
          <app-multi-select-dropdown *ngIf="organizations.length > 0" id="payment-history_vendor_filter"
            class="multiselect" [clicked]="clicked" [items]="organizations" [label]="'SURVEYS.MAP_VENDOR'"
            [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectVendor()">
          </app-multi-select-dropdown>
        </div>
        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist [filters]="selectedFilters" [useApply]="true"
            (resetFilterEmitter)="resetFilter()" (removeFilterEmitter)="removeFilter($event)"
            (applyFilterEmitter)="applyFilter()">
          </app-filter-checklist>
        </div>
      </div>

      <div class="table">
        <div *ngIf="paymentHistory">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="payment-history_table_header_app-no">{{'PAYMENT_HISTORY.APPLICATION_NUMBER' | translate}}</th>
                <th id="payment-history_table_header_acc-no">{{'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate}}</th>
                <th id="payment-history_table_header_map-id">{{'SURVEYS.MAP_ID' | translate}}</th>
                <th id="payment-history_table_header_map-id">{{ 'COMMON.MBC_DETAILS.METER_PHASE' | translate }}</th>
                <th id="payment-history_table_header_email">{{'COMMON.USER.EMAIL' | translate}}</th>
                <th id="payment-history_table_header_amount">{{'COMMON.AMOUNT' | translate}}</th>
                <th id="payment-history_table_header_process-fees">{{'PAYMENT_HISTORY.PROCESS_FEES' | translate}}</th>
                <th id="payment-history_table_header_status">{{'COMMON.PAYMENT_STATUS.SINGLE' | translate}}</th>
                <th id="payment-history_table_header_timestamp">{{'PAYMENT_HISTORY.DATE_TIMESTAMP' | translate}}</th>
                <th id="payment-history_table_header_map-vendor">{{'SURVEYS.MAP_VENDOR' | translate}}</th>
                <th id="payment-history_table_header_actions">{{'PAYMENT_HISTORY.ACTIONS' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr [id]="'payment-history_table_row-' + (i + 1)" *ngFor="let item of paymentHistory; let i = index">
                <td [id]="'payment-history_table_app-no-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.applicationNumber | hasValue }}</td>
                <td [id]="'payment-history_table_acc-no-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.accountNumber | hasValue }}</td>
                <td [id]="'payment-history_table_map-id-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.mapId | hasValue }}</td>
                <td [id]="'payment-history_table_meter-phase-' + (i + 1)" [routerLink]="['details', item.id]"
                  (click)="setFilterStorage()">{{ item.typeOfConnection | hasValue }}</td>
                <td [id]="'payment-history_table_email-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.email | hasValue }}</td>
                <td [id]="'payment-history_table_amount-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.amount | hasValue }}{{ item.amount != null ? ' ' + currency : '' }}</td>
                <td [id]="'payment-history_table_process-fees-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.processFees | hasValue }}{{ item.processFees != null ? ' ' + currency : '' }}</td>
                <td [id]="'payment-history_table_status-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">
                  <div *ngIf="item.paymentStatus" class="payment-status" [ngClass]="getStatusClass(item.paymentStatus)">
                    {{ getStatusKey(item.paymentStatus) | translate }}
                  </div>
                  <div *ngIf="!item.paymentStatus">
                    ----
                  </div>
                </td>
                <td [id]="'payment-history_table_timestamp-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">
                  {{ item.timestamp | utcDate }}</td>
                <td [id]="'payment-history_table_map-vendor-' + (i + 1)" [routerLink]="['details', item.id]" (click)="setFilterStorage()">{{ item.mapVendor | hasValue }}</td>
                <td [id]="'payment-history_table_actions-' + (i + 1)" class="actions-cell" (click)="setFilterStorage()">
                  <img [id]="'payment-history_table_action-view-' + (i + 1)" class="action-icon history"
                    src="../../assets/icons/eye.svg" alt="View" [routerLink]="['details', item.id]" />
                  <img [id]="'payment-history_table_action-history-' + (i + 1)" class="action-icon"
                    src="../../assets/icons/history-icon.svg" alt="History" />
                  <img [id]="'payment-history_table_action-more-' + (i + 1)" class="action-icon"
                    src="../../assets/icons/more-icon.svg" alt="More" />
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage"
              [useDirect]="true" (pageChange)="pageChange($event)"></app-paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
